/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */

import { jQuery } from '../other/jquery-hooked.js';


let MViewLinkUtil = function($) {

	var m_initialized = false;
	var m_available_view_link_targets = {};
	var m_next_view_link_target_id = 1;

	function init() {
		if( m_initialized ) return;
		m_initialized = true;
		$(document)
			.on( 'mjsviewlinkbecameavailable', function( e, vlti, elem ) {
				if( m_available_view_link_targets.hasOwnProperty(vlti) ) {
					// already known here
				} else {
					// add and notify others
					var notify_targets = getAvailableTargets();
					m_available_view_link_targets[vlti] = elem;
					notify_targets.trigger('mjsviewlinkotherbecameavailable',[vlti,elem]);
					// make all previously know to new elem
					$.each( m_available_view_link_targets, function(okey,oelem) {
						var ikey = parseInt(okey,10);
						if( ikey!==vlti ) $(elem).trigger('mjsviewlinkotherbecameavailable',[ikey,oelem]);
					} );
				}
			} )
			.on( 'mjsviewlinkgotlost', function( e, vlti ) {
				if( !m_available_view_link_targets.hasOwnProperty(vlti) ) {
					// already unknown here
				} else {
					// delete notify others
					var notify_targets = getAvailableTargets();
					var tmp = m_available_view_link_targets[vlti];
					delete m_available_view_link_targets[vlti];
					notify_targets.trigger('mjsviewlinkothergotlost',[vlti,tmp]);
				}
			} );
	}

	function getAvailableTargets() {
		return $( Object.values(m_available_view_link_targets) );
	}

	return {
		init: init,
		getAvailableTargets: getAvailableTargets,
		getNextLinkTargetId: function() {
			return m_next_view_link_target_id ++;
		},
	};
}(jQuery); // MViewLinkUtil

export {
	MViewLinkUtil,
};
